<template>
    <div>
        <router-link :to="{name: 'news'}" style="cursor:pointer; display:flex"><span class="material-icons">undo</span>назад</router-link>
        <h4>{{currentNews.title}}</h4>
        <p  style="white-space: break-spaces;text-indent: 20px;">{{currentNews.text}}</p>
        <hr/>
            <span style="font-style:italic;font-size:12px; color:gray">Обновлено: {{currentNews.createDate | date}}</span>
    </div>    
</template>

<script>
export default {
  data() {
      return {

      };
  },
  computed: {
      currentNews() {
          const current = this.$store.state.clinic.organization.form.front.news.find(obj => obj.id === parseInt(this.$route.params.id, 10));
          return current;
      }
  },
  filters: {
        date(str) {
            if (str) {
            const date = new Date(str);
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
          return date.toLocaleDateString('ru-RU', options);
        }
        }
    },
  mounted() {
      console.log(this.currentNews);
  }
};
</script>

<style lang="scss" scoped>

</style>